/**
 * Lead person-name helpers shared by API, app, and public profile forms.
 *
 * Leads store firstName + lastName separately. Display and legacy full-name
 * strings are derived or split here — never invent a third persisted name field.
 */

export function formatLeadDisplayName(
  firstName?: string | null,
  lastName?: string | null,
): string {
  return `${firstName?.trim() ?? ''} ${lastName?.trim() ?? ''}`.trim();
}

/**
 * Split a legacy full display name into given/family parts.
 * Last whitespace token → familyName; the rest → givenName.
 */
export function splitLeadDisplayName(displayName: string): {
  formattedName: string;
  familyName: string;
  givenName: string;
} {
  const trimmed = displayName.trim();
  if (!trimmed) {
    return { formattedName: '', familyName: '', givenName: '' };
  }

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return {
      formattedName: trimmed,
      familyName: parts[parts.length - 1] ?? '',
      givenName: parts.slice(0, -1).join(' '),
    };
  }

  return {
    formattedName: trimmed,
    familyName: '',
    givenName: trimmed,
  };
}

/** Collator key: last name first, then given name (for A–Z / Z–A sorts). */
export function leadNameSortKey(
  firstName?: string | null,
  lastName?: string | null,
): string {
  const given = firstName?.trim() ?? '';
  const family = lastName?.trim() ?? '';
  if (family) return `${family}\0${given}`;
  return given;
}
